import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  isMobile,
} from "react-device-detect";

import * as Actions from '../../store/actions';
import * as videoActions from '../../store/actions/video-actions';
import {
  startedWatch,
  toggleVideoPlayerReadyState,
} from '../../store/actions/play-actions';

import {
  toggleControlsVisibility
} from '../../store/actions/controls-visibility-actions'

import { loadImages } from '../../store/actions/imagesLoad';
import HlsVideoPlayer from '../videojs-hls/VideojsHLS.jsx';
import { getOrientation } from '../../tools/utils';
import cx from 'classnames';
import AppConfig from '../../AppConfig';
import PlayIcon from '../../components/svg-icons/PlayIcon';
import PauseIcon from '../../components/svg-icons/PauseIcon';
import BellPlay from '../../components/BellPlay';
import ImageFrame from '../../components/ImageFrame';
import {
  getBookFramesTime,
  getEncriptedImages,
  getRealDuration,
  getImageSlides,
  getBookState,
  getIsWidget,
  getViewMode,
  getAudioHLSUrl,
  getVideoHLSUrl,
  getBookTexts,
  getBookType,
  getBookId,
  getGalleryVisibility,
  getActiveFrame,
  getBookCover,
  getIsStarted,
  getIsFullscreen,
  getIsPlaying,
  getIsDemo,
  getIsFree,
  getPLAYER,
  getIsPlayerReady,
  getIsBellEnabled,
  getAutoPlay,
  getCurrentAudioChapter,
  getAudioBookStream,
  getIsAudioBook,

} from '../../store/selectors/selectors'

import './style.scss';

const {
  BOOK_TYPES: {
    AUDIO,
    AUDIO_BOOK
  }
} = AppConfig;


class VideoPlayer extends Component {

  // for click & double click at video
  vClickTimer = 0;
  vClickDelay = 400;
  vClickPrevent = false;

  constructor() {
    super();
    this.frameImage = null;
    this.isFirstImageLoaded = false;
    this.videoContainer = React.createRef();
  }

  playPause = () => {
    if (this.props.isPlaying) {
      // this.props.PLAYER.pause()
      this.props.togglePlay(false)
    } else {
      // this.props.PLAYER.play()
      this.props.togglePlay(true)
    }
  };

  onReady = () => {
    if (!this.props.isWitget) {
      window.parent.postMessage("web-viewer-ready", "*");
    }

    this.props.toggleVideoPlayerReadyState(true);
    let autoPlay = this.props.autoPlay;
    //todo: для аудиокниг во viewMode ["audio"]. Нужно сделать более очевидный разрул между книгами/типами книг
    if (this.props.viewMode === 'video' || this.props.viewMode.includes("audio")) {
      if (autoPlay == true || autoPlay == 'true') {
        this.onPlayExtra();
      }
    }
  };

  onPlayExtra = () => {
    this.vClickTimer = setTimeout(() => {
      if (this.vClickPrevent === false && !this.props.waitingForAction) {
        this.playPause();
        this.props.startedWatch(true);
      }
      this.vClickPrevent = false;
    }, this.vClickDelay);
  };

  handleDoubleClick = (event) => {
    const { isPlayerReady } = this.props;
    const headerControls = document.getElementById('toolbar-header-controls');

    if (isPlayerReady &&
      this.props.isStarted &&
      !(headerControls && headerControls.contains(event.target))
    ) {
      clearTimeout(this.vClickTimer);
      this.vClickPrevent = true;
      this.props.onClickFullscreen();
    }
  };

  handleTouchEnd = (e) => {
    if (e.target.classList.contains('play-block-center')) {
      this.props.toggleControlsVisibility();
    }
  }
  /**
   * Check is mode (video/audio) is allowed for this type of book
   * @returns {*}
   */
  isAllowedMode() {
    const {
      bookType
    } = this.props;
    // for text|audio mode only video is absent
    if (bookType && (AppConfig.BOOK_TYPE_MODES[bookType].includes('video')||
      [AUDIO, AUDIO_BOOK].includes(bookType))
    ) {
      return true;
    } else {
      return null;
    }
  }

  render() {
    // for text|audio mode only video is absent
    if (!this.isAllowedMode()) {
      return null;
    }

    const {
      visible,
      viewMode,
      video,
      isStarted,
      galleryVisibility,
      activeFrame,
      isPlayerReady,
      isSliderView,
      audio,
      controlsState,
      isPlaying,
      encriptedImages,
      posterUrl,
      audioBookStream,
      isAudioBook,
    } = this.props;
    const activeFrameImage = encriptedImages[activeFrame];


    if (isSliderView) {
      this.frameImage = activeFrameImage;
    }

    if (viewMode === 'audio') {
      this.frameImage = null;
    }

    if(getOrientation() === 'portrait' && activeFrame === -1) {
      this.frameImage = posterUrl
    }

    let url = (viewMode === 'audio' || isSliderView) ? audio.download_link : video.download_link;

    if (isAudioBook) {
      url = audioBookStream;
    }

    return (
      <div
        className={cx(
          'cnb-player cnb-video-player',
          {
            'hidden': !visible,
            'is-blurred': galleryVisibility
          }
        )}
        ref={this.videoContainer}
      >


        {isPlayerReady && isSliderView && viewMode === 'video' &&
          this.frameImage &&
            <ImageFrame
              image={activeFrameImage}
            />
        }

        {url &&
          <HlsVideoPlayer
            url={url}//data
            isPlaying={isPlaying}//data
            activeFrame={activeFrame}//data
            viewMode={viewMode}//data
            onReady={this.onReady}//calback
          />
        }

        <div
          className={
            cx(
              'play-block-center',
              {
                'play-block-center--ready': isPlayerReady,
                'play-block-center--play': isPlaying,
                'play-block-center--pause': !isPlaying,
                'play-block-center--hide': viewMode !== 'video',
                'play-block-center--played': isStarted,
                'play-block-center--show': controlsState.isVisible,
              }
            )
          }
          onClick={!isMobile ? this.onPlayExtra : undefined}
          onDoubleClick={this.handleDoubleClick}
          onTouchEnd={this.handleTouchEnd}
        // onMouseMove={this.onMouseMove}
        >
          <button
            className="play-block-center__button"
            onClick={isMobile ? this.onPlayExtra : undefined}
          >
            <PlayIcon />
            <PauseIcon />
          </button>
        </div>
        <BellPlay
          soundEnabled={visible && isSliderView && this.props.isBellEnabled}
          activeFrame={activeFrame}
        />
      </div>
    );
  }

}


const mapStateToProps = (state) => {

  const { controlsState } = state;
  const bookType = getBookType(state);
  const isStarted = getIsStarted(state);
  return {
    controlsState,
    images: getImageSlides(state),
    encriptedImages: getEncriptedImages(state),
    book: getBookState(state),
    isWidget: getIsWidget(state),
    visible: getViewMode(state) !== 'text',
    viewMode: getViewMode(state),
    video: getVideoHLSUrl(state),
    audio: getAudioHLSUrl(state),
    audioBookStream: getAudioBookStream(state),
    text: getBookTexts(state),
    bookId: getBookId(state),
    galleryVisibility: getGalleryVisibility(state),
    framesData: getBookFramesTime(state),
    activeFrame: getActiveFrame(state),
    posterUrl: getBookCover(state),
    isFullscreen: getIsFullscreen(state),
    isPlaying: getIsPlaying(state),
    isPlayerReady: getIsPlayerReady(state),
    isAudioBook: getIsAudioBook(state),
    isStarted,
    isSliderView: bookType === 'photo-illustrated book',
    isDemo: getIsDemo(state),
    isFree: getIsFree(state),
    realDuration: getRealDuration(state),
    PLAYER: getPLAYER(state),
    isBellEnabled: getIsBellEnabled(state),
    bookType,
    autoPlay: getAutoPlay(state),
    currentAudioChapter: getCurrentAudioChapter(state),
    waitingForAction: state.videoPlayerState.waitingForAction
  }
};

const actionCreators = {
  ...Actions,
  loadImages,
  ...videoActions,
  toggleVideoPlayerReadyState,
  startedWatch,
  toggleControlsVisibility,
}
export default connect(mapStateToProps, actionCreators)(VideoPlayer);


// WEBPACK FOOTER //
// ./src/containers/video-player/VideoPlayer.jsx